import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { SesiuneCadou } from './pages/SesiuneCadou';
import { Testimoniale } from './pages/Testimoniale';
import { Contact } from './pages/Contact';
import { Despre } from './pages/Despre';
import { Workshop } from './pages/Workshop';
import { OfertaRise } from './pages/OfertaRise';
import { ProgramulRise } from './pages/ProgramulRise';
import { ComunitateRise } from './pages/ComunitateRise';
import { Coaching1la1 } from './pages/Coaching1la1';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2wj8cxn0bok3n">
      <ScrollToTop data-id="element-1" data-mp="2wip5j08ate3v" />
      <div className="min-h-screen bg-rise-black text-rise-white selection:bg-rise-gold/30" data-id="element-2" data-mp="2wi5lndz38fn7">
        <Navbar data-id="element-3" data-mp="28sbe9bxjfjac" />
        <Routes data-id="element-4" data-mp="23vcm2yxfpmes">
          <Route path="/" element={<Home data-id="element-6" data-mp="23ujk0b9f7l2z" />} data-id="element-5" data-mp="23vupcfiil0w7" />
          <Route path="/acasa" element={<Home data-id="element-8" data-mp="3ijxo6nd1puib" />} data-id="element-7" data-mp="23v2sl1d6kx4c" />
          <Route path="/sesiune1la1" element={<SesiuneCadou data-id="element-10" data-mp="3ijfv1zlojwem" />} data-id="element-9" data-mp="3ikh5c1uvgeva" />
          <Route path="/testimoniale" element={<Testimoniale data-id="element-12" data-mp="3mkre1ma1tjdu" />} data-id="element-11" data-mp="3ii4r9zs8ioni" />
          <Route path="/contact" element={<Contact data-id="element-14" data-mp="3mj6k9yvk64h1" />} data-id="element-13" data-mp="3mjzrt22ccy08" />
          <Route path="/despremine" element={<Despre data-id="element-16" data-mp="3rdkh85pvcjnt" />} data-id="element-15" data-mp="3rbr9so7flver" />
          <Route path="/workshop" element={<Workshop data-id="element-18" data-mp="5or2zhbcs60" />} data-id="element-17" data-mp="3recf5n6xuth9" />
          <Route path="/ofertarise" element={<OfertaRise data-id="element-20" data-mp="56l3b4umzkw" />} data-id="element-19" data-mp="4wvhonpuufq" />
          <Route path="/oferterise" element={<OfertaRise data-id="element-22" data-mp="2zm4y4lnitf2c" />} data-id="element-21" data-mp="2zl3brl12165b" />
          <Route path="/programulrise" element={<ProgramulRise data-id="element-24" data-mp="33mowfsjtyoq2" />} data-id="element-23" data-mp="2zmo89g6xiz5t" />
          <Route path="/comunitaterise" element={<ComunitateRise data-id="element-26" data-mp="33myix65o2dr0" />} data-id="element-25" data-mp="33lx18iu5at0b" />
          <Route path="/coaching1la1" element={<Coaching1la1 data-id="element-28" data-mp="38kqfwel64q22" />} data-id="element-27" data-mp="38m1fs3bhtdnw" />
        </Routes>
        <Footer data-id="element-29" data-mp="38o4edbqpof48" />
      </div>
    </BrowserRouter>;
}